module.exports = __webpack_public_path__ + "img/success_inbox.ca2d92a2.svg";